<template>
  <div class="container">
    <div class="title">
      <img src="../../../static/image/task/task-icon3 (1).png" alt />
      <div class="title-text">
        <div class="num">发布：{{totalCount}}</div>
<!--        <div class="but">客服</div>-->
      </div>
    </div>

    <div class="other">
      <div class="other-title">其他发布</div>
      <div class="hr"></div>
      <div v-for="(item,index) in newProList" style="position: relative;">
        <img :key="index" :src="item.squarePicture"  @click="goTaskDetail(item)" alt v-if="index<3" />
        <!--      <div>{{item.name}}</div>-->
        <div style="display: inline-block;width: 100%;background-color: #fde7c1;position:absolute;bottom: 15px;left:0;height: 30px;line-height: 30px;opacity: 0.6;color: #3A3A3A;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;" v-if="index<3">{{item.name}}</div>
      </div>

    </div>
  </div>
</template>

<script>
import config from "../../api/config";

export default {
  name: "sideNavigationBar",
  data() {
    return {
      newProList:[],
      totalCount:0
    };
  },
  created() {
    this.getLatestTask();
    // this.getProductList(1);
    // this.getProductList(2);
    // this.getProductList(3)
  },
  methods: {
    async getLatestTask() {
      const res = await this.$http.latestTask()
      if (res.code == 200) {
        if(res.result){
          res.result.forEach((item)=>{
            item.squarePicture = item.squarePicture.indexOf("http")>-1||item.squarePicture.indexOf("https")>-1?item.squarePicture:config.baseImgUrl+item.squarePicture
          })
          this.newProList = res.result;
          this.getProductList(1);
        }else{
          this.newProList = [];
        }
      }
    },
    goTaskDetail(record) {
      console.log(222222222222,record.id);
      this.$router.push({
        path: "/task/taskDetail",
        query: {id: record.id},
      });
      console.log(333333333);
    },
    //获取设计列表
    async getProductList(queryType) {
      try {
        let data = {
          pageIndex:1,
          pageSize: 10,
          queryType:queryType,
          val: '',
        }
        const res = await this.$http.getMissionList(data)
        if (res.code == 200) {
          if(res.result){
            this.totalCount += res.result.total;
          }else{
            this.productList = [];
          }
          if(queryType == 1){
            this.getProductList(2);
          }else if(queryType == 2){
             this.getProductList(3)
          }

        } else {
          // this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
.container {
  width: 100%;
}
.title {
  background: #ffffff;
  /* width: 100%; */
  padding: 18px 27px 27px 27px;
  text-align: center;
}
.title img {
  width: 101px;
  height: 101px;
  border-radius: 50%;
}
.title-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #3a3a3a;
  opacity: 1;
  margin: 38px 0 0 0;
}
.num {
}
.but {
  background: #ffffff;
  border: 1px solid #9e9e9e;
  opacity: 1;
  border-radius: 5px;
  padding: 0 24px;
}
.other {
  /* width: 100%; */
  background: #ffffff;
  padding: 0 27px 0 27px;
  margin: 21px 0 0 0;
  text-align: center;
}
.hr {
  border-bottom: solid 1px #c7c7c7;
  margin: 0 -24px 19px -24px;
}
.other-title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #3a3a3a;
  opacity: 1;
  padding: 15px 0;
  text-align: left;
}
.other img {
  margin: 0 0 15px 0;
  width: 100%;
  /*height: 210px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/sideNavigationBar/sideNavigationBar.vue